import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppointmentScreenWrapper", {
    attrs: { "data-qa": "appointment_success" },
    scopedSlots: _vm._u([
      {
        key: "main",
        fn: function () {
          return [
            _c(VImg, {
              staticClass: "mx-auto",
              attrs: {
                contain: "",
                width: _vm.isClubAvailable ? 72 : 130,
                height: _vm.isClubAvailable ? 72 : 130,
                src: _vm.urls.iconSuccess,
                alt: _vm.successData.title,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text--text mt-4 text-center",
                class: {
                  "text-h5": _vm.isClubAvailable,
                  "text-h6": !_vm.isClubAvailable,
                },
                attrs: { "data-qa": "appointment_success_title" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t(_vm.successData.title, _vm.options)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.successData.subtitle
              ? _c(
                  "div",
                  {
                    staticClass: "text-center mt-2 mx-auto",
                    class: {
                      "text-body-1 text--text": _vm.isClubAvailable,
                      "text-body-2 text-secondary--text": !_vm.isClubAvailable,
                    },
                    style: { width: "80%" },
                    attrs: { "data-qa": "appointment_success_subtitle" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t(_vm.successData.subtitle, _vm.options)) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.successData.showPhone
              ? _c(
                  _vm.isMobile ? "a" : "div",
                  {
                    tag: "component",
                    staticClass: "text-body-1 primary--text text-center",
                    class: {
                      "d-block text-decoration-none": _vm.isMobile,
                    },
                    attrs: {
                      href: _vm.isMobile
                        ? `tel:${_vm.formattedLpuPhone}`
                        : null,
                    },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.lpuData.phone) + "\n    ")]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function ({ buttonProps }) {
          return [
            _vm.isWithMedtochkaAppLink
              ? [
                  _c(
                    VBtn,
                    _vm._b(
                      {
                        staticClass: "my-3",
                        attrs: {
                          "data-qa": "appointment_success_redirect_btn",
                          color: "bg-primary",
                          href: _vm.successData.medtochkaUrl,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleClickDetailButton.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      "v-btn",
                      buttonProps,
                      false
                    ),
                    [
                      _c("span", { staticClass: "primary--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Детали записи", _vm.options)) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.successData.isEnableMedtochkaRedirect
                    ? _c("MedtochkaRedirect", {
                        attrs: {
                          "redirect-url": _vm.successData.medtochkaUrl,
                          "data-qa": "appointment_success_redirect_timer",
                        },
                      })
                    : _vm._e(),
                ]
              : [
                  _vm.currentActions.buttonFirst
                    ? _c(
                        VBtn,
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                "data-qa": "appointment_success_first_button",
                              },
                            },
                            "v-btn",
                            buttonProps,
                            false
                          ),
                          _vm.currentActions.buttonFirst.on
                        ),
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  _vm.currentActions.buttonFirst.text,
                                  _vm.options
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentActions.buttonSecond
                    ? _c(
                        VBtn,
                        _vm._g(
                          _vm._b(
                            {
                              class: { "mt-3": _vm.currentActions.buttonFirst },
                              attrs: {
                                "data-qa": "appointment_success_second_button",
                                text: "",
                              },
                            },
                            "v-btn",
                            buttonProps,
                            false
                          ),
                          _vm.currentActions.buttonSecond.on
                        ),
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  _vm.currentActions.buttonSecond.text,
                                  _vm.options
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }